import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Depot } from '../models/Depot'

type SaveDepotPayload = {
  depot: Record<string, unknown>
}

export const saveDepot = createAsyncThunk<Depot, SaveDepotPayload, ThunkApiContext>('depots/saveDepot', async ({ depot }: SaveDepotPayload, { dispatch }) => {
  const response = await OLMSApiService.post<Depot>('depot/save', depot)

  if (!response) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Save depot',
      content: 'Failed to save depot',
    }))
    throw new Error('Failed to save depot')
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Save depot',
    content: `Successfully saved depot ${response.name}`,
  }))

  return response
})
